import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  promoWrapper: css`
    padding: ${spacing(2)};
    padding-block-start: ${spacing(3)};
  `,
  drawerSection: css`
    background: var(--colorScheme-bgMinor, #f5f4f2);
    border-radius: ${spacing(3)};
    &:last-child {
      border-end-start-radius: 0;
      border-end-end-radius: 0;
    }
    & + & {
      margin-block-start: ${spacing(1)};
    }
  `,
  content: css`
    display: flex;
    flex-direction: column;
  `,
  bannerContainer: css`
    padding: 8px;
  `,
}
